module.exports = __webpack_public_path__ + "static/media/sfwit.0ba29611.png";